import React, { useEffect, useState } from "react";
import SingleCard from "../AdsPage/SingleCard";
import Pagination from "../Pagination"; // Adjust the import path as necessary
import { Box, CircularProgress, Typography, Alert, Grid } from "@mui/material";
import AnalyticsTracker from "../GASetup/AnalyticsTracker";
import { Helmet } from "react-helmet-async";
import { fonts, headingFonts } from "../../Styles/Styles";
import LoadingAnimation from "../Animations/LoadingAnimation";

const SoldAds = () => {
  const [ads, setAds] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSoldAds = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/filters/is-sold?page=${currentPage}&limit=10`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setAds(data.ads);
        setTotalPages(data.totalPages);
      } catch (err) {
        setError("Error fetching sold ads: " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSoldAds();
  }, [currentPage]);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Helmet>
        <title>Sold Ads - Listed.ky</title>
        <meta name="description" content="Sold Ads - Listed.ky" />
      </Helmet>
      <AnalyticsTracker />
      <Typography variant="h4" gutterBottom sx={{ ...headingFonts }}>
        Sold Ads
      </Typography>

      {/* Loading Spinner */}
      {loading && <LoadingAnimation />}

      {/* Error Message */}
      {error && <Alert severity="error">{error}</Alert>}

      {/* Ads Grid */}
      {!loading && !error && ads.length === 0 ? (
        <Typography variant="body1" align="center" mt={4} sx={{ ...fonts }}>
          No sold ads found.
        </Typography>
      ) : (
        <Grid container spacing={4}>
          {ads.map((AdInfo) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={AdInfo._id}>
              <SingleCard AdInfo={AdInfo} />
            </Grid>
          ))}
        </Grid>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <Box sx={{ mt: 4 }}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default SoldAds;
